import { ArrowDownToLineIcon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { DepositToWethAction } from './types'

export interface DepositToWethActionRowProps extends ActionRowBaseProps {
  action: DepositToWethAction
}

export function DepositToWethActionRow({ action, ...props }: DepositToWethActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowDownToLineIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.eth]} />
        Wrap ETH
      </ActionRow.Title>

      <ActionRow.Amount token={action.eth} amount={action.value} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Wrap</ActionRow.Trigger>
    </ActionRow>
  )
}
